export type QuizTermsLang = 'id' | 'en'

export const quizTermsCopy: Record<
	QuizTermsLang,
	{
		title: string
		pageTitle: string
		items: string[]
	}
> = {
	id: {
		title: 'Syarat & Ketentuan',
		pageTitle: 'Syarat & Ketentuan Quiz Mie Ayam GAGA',
		items: [
			'10 Pemenang akan diumumkan setiap minggu melalui media sosial dan papan pengumuman di Booth Gaga Mie Ayam selama PRJ berlangsung.',
			'Hadiah berupa 12 pcs Gaga Mie Ayam akan dikirim setiap bulan selama 1 tahun.',
			'Keputusan juri bersifat final dan tidak dapat diganggu gugat.'
		]
	},
	en: {
		title: 'Terms & Conditions',
		pageTitle: 'GAGA Mie Ayam Quiz Terms & Conditions',
		items: [
			'10 winners will be announced weekly via social media and notice boards at the GAGA Mie Ayam Booth during PRJ.',
			'The prize of 12 pcs GAGA Mie Ayam will be delivered monthly for 1 year.',
			"The jury's decision is final and binding."
		]
	}
}
